import { useCallback, useState } from 'react';
import type { AppProvisioning, ProvisionedRegistryApp } from '@/api/console';
import { provisioningNeedsAttention } from './provisioning';

/**
 * EAA-1709: holds a create/update response's `provisioning` block while the
 * operator reads it. `handleResult` either keeps it (a one-time secret or a
 * failed step to show — `onDone` waits until `close`) or calls `onDone` at once.
 * The secret lives here, in component state, and nowhere else.
 */
export function useProvisioningResult(onDone: () => void) {
    const [provisioning, setProvisioning] = useState<AppProvisioning | null>(null);

    const handleResult = useCallback(
        (row: ProvisionedRegistryApp) => {
            if (row.provisioning && provisioningNeedsAttention(row.provisioning)) {
                setProvisioning(row.provisioning);
                return;
            }
            onDone();
        },
        [onDone]
    );

    const close = useCallback(() => {
        setProvisioning(null);
        onDone();
    }, [onDone]);

    return { provisioning, handleResult, close };
}
